import { QuickSearchResponseRecord } from '@/search/types'
import { BlogSearchResult } from '../SearchResult'
import { NoResults } from '../NoResults'
import { SearchWelcome } from '../SearchWelcome'
import { LoadingSpinner } from '@/General/LoadingSpinner'

export const BlogSearchResultsList = ({
  results,
  isLoading,
  searchTerm,
}: BlogSearchResultsListProps) => {
  return (
    <div>
      {isLoading ? (
        <LoadingSpinner />
      ) : !searchTerm ? (
        <SearchWelcome />
      ) : !results || results.length === 0 ? (
        <NoResults />
      ) : (
        results?.map(result => (
          <BlogSearchResult
            key={result.objectId}
            objectId={result.objectId}
            thumbnail={result.thumbnailUrl}
            title={result.title}
            creators={result.creators}
            productUrl={result.productUrl}
            categories={result.categories}
            dateAdded={result.dateAdded as number | string | undefined}
          />
        ))
      )}
    </div>
  )
}

interface BlogSearchResultsListProps {
  results: QuickSearchResponseRecord[]
  isLoading: boolean
  searchTerm: string
}

